export default {
  setTokenInformation(payload, userinfo) {
    var paramsQuery = payload.QueryString.split("&");
    let encCompanyId = "",
      encAdviserId = "",
      encClientId = "";
    for (let i = 0; i < paramsQuery.length; i++) {
      var arrsplit = paramsQuery[i].split("|=|");
      switch (arrsplit[0]) {
        case "encCompanyId":
          encCompanyId = arrsplit[1];
          break;
        case "encAdviserId":
          encAdviserId = arrsplit[1];
          break;
        case "ClientID":
          encClientId = arrsplit[1];
          break;
      }
    }
    return {
      encAdviserId: encAdviserId,
      encCompanyId: encCompanyId,
      encClientId: encClientId,
      wrapCode: payload.wrapCode,
      adviserId: userinfo.adviserId,
      companyId: userinfo.companyId,
      clientId: userinfo.clientId,
    };
  },
};
